module.exports = __webpack_public_path__ + "static/media/logo.347de3c1.svg";